import React from 'react';
import './ErrorPage.scss';
import SpinnerSga from '../UI/SpinnerSga';

const Forbidden403 = () => {
    return (
        <section className="error-page">
            <div className="description">
                <p className="gray-text">Błąd</p>
                <div className="container">
                    <p className="code">#403</p>
                    <p className="break-text">
                        <span>Odmowa</span>
                        <span>dostępu</span>
                    </p>
                </div>
                <p className="uppercase-text">Brak dostępu do strony!</p>
                <p className="text">Wygląda na to, że nie posiadasz wymaganych uprawnień aby wyświetlić zawartość tej strony.</p>
                <p className="text padding">W razie pytań prosimy o kontakt:</p>
                <address className="address">
                    <dl className="contact">
                        <dt className="contact__list">
                            <i className="material-icons">mail_outline</i> <a className="list__item" href="mailto:sga@sga.waw.pl">sga@sga.waw.pl</a>
                        </dt>
                        <dt className="contact__list">
                            <i className="material-icons">phone</i> <a className="list__item" href="tel:81-534-21-05">(81) 534 21 05</a>
                        </dt>
                    </dl>
                </address>
            </div>
            <SpinnerSga />
        </section>
    );
}

export default Forbidden403;